import { render, staticRenderFns } from "./iconCurrency.vue?vue&type=template&id=7400d9b2"
import script from "./iconCurrency.vue?vue&type=script&lang=js"
export * from "./iconCurrency.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports